import type { MediaAsset } from '@/types/api/assets';
import type { ImageFile } from 'web';

export function coverImageFromAsset(asset: MediaAsset): ImageFile {
  return {
    url: asset.url,
    thumbnailUrl: asset.thumbnailUrl,
    width: asset.width ?? 0,
    height: asset.height ?? 0,
    publicId: asset.publicId,
    id: asset.id,
    blobstore: asset.blobstore,
  };
}
